<template>
    <div>
        <Card>
            <p slot="title"> List Deposit </p>
            <Form :label-width="120">
                <Form-item label="Tgl Deposit">
                    <Row>
                        <Col span="4">
                            <Date-picker v-model="paymentDeposit"
                                style="width: 110px;"
                                type="date"
                                format="dd/MM/yyyy">
                            </Date-picker>
                        </Col>

                        <Col span="3">
                            <i-switch size="large" v-model="isGroup">
                                <span slot="open">Group</span>
                                <span slot="close">Mark</span>
                            </i-switch>
                        </Col>

                        <Col span="5" v-show="isGroup == false">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Marking"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getDepositMarking" >
                                <Option v-for="option in optionMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col>

                        <Col span="5" v-show="isGroup == true">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Group Name"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getGroupMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getDepositGroupMarking" >
                                <Option v-for="option in optionGroupMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col>
                        <Col span="1" offset="1">
                            <Spin size="large" v-show="loadingGetDeposit"></Spin>
                        </Col>
                    </Row>
                </Form-item>  
            </Form>
        </Card>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { HTTP } from '../http-lib';
import { Money } from 'v-money'

const numeral = require('numeral');
var axios = require('axios');

export default {
    components : { Money },

    data: () => ({
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        paymentDeposit: null,
        isGroup : false,
        markingIdSelected : '',
        loadingGetMarking: false,
        optionMarkings : [],
        optionGroupMarkings : [],
        
        loadingGetDeposit : false,
    }),
    methods: {
        getDepositMarking: function(){
        
        },

        getDepositGroupMarking: function(){
        
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && this.isGroup == false) {
                    this.loadingGetMarking = true;

                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGroupMarkingByCode:  _.debounce(
            function (query) {
                if (query !== '' && this.isGroup == true) {
                    this.loadingGetMarking = true;

                    HTTP
                    .post('markingGroup/getByCode', {
                        groupName: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.id,
                                label: item.code
                            };
                        });

                        this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
    },
    filters: {
        currency: function (value) {
        if (!value) return ''
        return numeral(value).format('0,0')
        }
    }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// DepositAdd.vue?336d6627